import React from 'react';
import { ArrowRight } from 'lucide-react';
type WidgetProps = {
  title: string;
  /** Optional small descriptor shown to the right of the title */
  badge?: React.ReactNode;
  /** Optional content shown in the header right-side (filters, CTAs, tabs, etc.) */
  headerRight?: React.ReactNode;
  /** Optional footer content. If `footerCta` is provided, it overrides this. */
  footer?: React.ReactNode;
  /** Convenience: a single right-aligned CTA link rendered in the footer. */
  footerCta?: {
    label: string;
    onClick?: () => void;
  };
  /** Controls inner padding of the body. Defaults to 'md' (p-5). */
  bodyPadding?: 'none' | 'sm' | 'md';
  className?: string;
  children: React.ReactNode;
};
const PADDING: Record<NonNullable<WidgetProps['bodyPadding']>, string> = {
  none: '',
  sm: 'p-4',
  md: 'p-5'
};
export function Widget({
  title,
  badge,
  headerRight,
  footer,
  footerCta,
  bodyPadding = 'md',
  className = '',
  children
}: WidgetProps) {
  const hasFooter = !!footer || !!footerCta;
  return <div className={`bg-[#181818] border border-[#262626] rounded-xl flex flex-col h-full ${className}`} data-id="element-4193">
      {/* HEADER */}
      <div className="p-4 sm:p-5 border-b border-[#262626] flex items-start sm:items-center justify-between gap-3 flex-wrap" data-id="element-4194">
        <div className="flex items-center gap-2 min-w-0" data-id="element-4195">
          <h3 className="text-base font-semibold text-[#FAFAFA] font-heading truncate" data-id="element-4196">
            {title}
          </h3>
          {badge}
        </div>
        {headerRight && <div className="flex items-center gap-2 flex-wrap" data-id="element-4197">{headerRight}</div>}
      </div>

      {/* BODY */}
      <div className={`flex-1 min-w-0 ${PADDING[bodyPadding]}`} data-id="element-4198">{children}</div>

      {/* FOOTER */}
      {hasFooter && <div className="border-t border-[#262626] px-4 sm:px-5 py-3" data-id="element-4199">
          {footer ? footer : footerCta ? <div className="flex items-center justify-end" data-id="element-4200">
              <button type="button" onClick={footerCta.onClick} className="inline-flex items-center gap-1 text-xs font-medium text-[#9A9A9A] hover:text-[#D4FF3A] transition" data-id="element-4201">
                {footerCta.label}
                <ArrowRight className="h-3.5 w-3.5" data-id="element-4202" />
              </button>
            </div> : null}
        </div>}
    </div>;
}